import React from 'react';
import withIcon from '../utilities/withIcon';

const IconSlider = () => {
  return (
    <g>
      <path d="m14.3677 6.24h-4.7531a3.5191 3.5191 0 0 0 -6.1369.0082c-.0143-.0006-.0263-.0082-.0407-.0082h-1.8047a1.5717 1.5717 0 0 0 -1.57 1.57v.3789a1.5717 1.5717 0 0 0 1.57 1.57h1.7813c.0219 0 .04-.0106.0618-.0125a3.5191 3.5191 0 0 0 6.1392.0136h4.7531a1.5717 1.5717 0 0 0 1.57-1.57v-.3794a1.5716 1.5716 0 0 0 -1.57-1.5706zm-12.8057 2.02v-.52h1.4609c-.0065.0873-.0263.1708-.0263.26s.02.1724.0263.26zm4.9863 1.792a2.0518 2.0518 0 1 1 2.0517-2.052 2.0547 2.0547 0 0 1 -2.0516 2.0518zm7.89-1.792h-4.3645c.0062-.0876.0262-.1711.0262-.26s-.02-.1724-.0263-.26h4.3643z" />
    </g>
  );
};

export default withIcon(IconSlider);
